import { render, staticRenderFns } from "./icon-view.vue?vue&type=template&id=00f105d0&lang=pug&"
var script = {}
import style0 from "./icon-view.vue?vue&type=style&index=0&id=00f105d0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports